<!-- =====================================================
     PARAMETERDATEIEN

     Backups der Gerätekonfiguration. Mehrere Stände je Datei
     bleiben nebeneinander erhalten – ein Backup, das ein
     älteres überschreibt, wäre wertlos.
     ===================================================== -->
<mat-card class="section-card">
  <mat-card-content>

    <h2 class="section-title small">
      <mat-icon class="titel-icon">save</mat-icon>
      Parameterdateien
      <span class="anzahl" *ngIf="parametersaetze.length">{{ parametersaetze.length }}</span>
    </h2>

    <div class="lade" *ngIf="isLoading">
      <mat-spinner diameter="28"></mat-spinner>
    </div>

    <p class="fehler" *ngIf="loadError">
      <mat-icon>error_outline</mat-icon>
      {{ loadError }}
    </p>


    <ng-container *ngIf="!isLoading && artefakte">

      <div class="bereich-aktionen" *ngIf="canEdit && !satzForm">
        <button mat-stroked-button color="primary" type="button" (click)="neuerSatz()">
          <mat-icon>add</mat-icon>
          Neue Parameterdatei
        </button>
      </div>


      <!-- Formular: anlegen und bearbeiten -->
      <div class="form-box" *ngIf="satzForm">

        <h3 class="form-titel">
          {{ satzForm.id == null ? 'Neue Parameterdatei' : 'Parameterdatei bearbeiten' }}
        </h3>

        <!-- Datei ist nur beim NEUANLEGEN erforderlich -->
        <div class="neue-parameterdatei-upload" *ngIf="satzForm.id == null">

          <input type="file" hidden #neueParameterDateiInput (change)="onNeueSatzDateiAusgewaehlt($event)">

          <!-- Noch keine Datei gewählt -->
          <div class="upload-zeile" *ngIf="!satzForm.datei">

            <button mat-stroked-button color="primary" type="button" [disabled]="savingSatz"
              (click)="neueParameterDateiInput.click()">

              <mat-icon>upload_file</mat-icon>
              Parameterdatei auswählen

            </button>

            <span class="upload-hinweis">
              Wähle den exportierten Parameterstand des Geräts aus.
            </span>

          </div>


          <!-- Datei gewählt -->
          <div class="upload-datei" *ngIf="satzForm.datei as datei">

            <mat-icon>insert_drive_file</mat-icon>

            <div class="upload-datei-info">

              <span class="upload-name">
                {{ datei.name }}
              </span>

              <span class="upload-groesse">
                {{ groesse(datei.size) }}
              </span>

            </div>

            <button mat-icon-button type="button" [disabled]="savingSatz" (click)="entferneNeueSatzDatei()"
              matTooltip="Datei entfernen">

              <mat-icon>close</mat-icon>

            </button>

          </div>

        </div>

        <div class="form-grid">

          <mat-form-field appearance="outline">
            <mat-label>Bezeichnung</mat-label>
            <input matInput [(ngModel)]="satzForm.bezeichnung" [disabled]="savingSatz"
              placeholder="z. B. Grundparametrierung Durchflussmesser">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Hersteller</mat-label>
            <input matInput [(ngModel)]="satzForm.geraeteHersteller" [disabled]="savingSatz">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Gerätetyp</mat-label>
            <input matInput [(ngModel)]="satzForm.geraeteTyp" [disabled]="savingSatz">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Seriennummer</mat-label>
            <input matInput [(ngModel)]="satzForm.seriennummer" [disabled]="savingSatz">
          </mat-form-field>

          <mat-form-field appearance="outline" class="voll">
            <mat-label>Beschreibung</mat-label>

            <input matInput [(ngModel)]="satzForm.bezeichnung" [disabled]="savingSatz"
              placeholder="z. B. Grundparametrierung Durchflussmesser">
            <textarea matInput rows="2" [(ngModel)]="satzForm.beschreibung" [disabled]="savingSatz"></textarea>
          </mat-form-field>

          <mat-form-field appearance="outline" class="voll" *ngIf="satzForm.id == null">

            <mat-label>
              Kommentar zum ersten Stand (optional)
            </mat-label>

            <input matInput [(ngModel)]="satzForm.kommentar" [disabled]="savingSatz"
              placeholder="z. B. Parameterstand nach Erstinbetriebnahme">

          </mat-form-field>

        </div>

        <mat-checkbox [(ngModel)]="satzForm.istVertraulich" [disabled]="savingSatz || !canSeeZugangsdaten"
          class="vertraulich-schalter">
          Vertraulich – Download nur für Berechtigte
        </mat-checkbox>

        <p class="hinweis" *ngIf="!canSeeZugangsdaten">
          <mat-icon>info_outline</mat-icon>
          Als vertraulich markieren kann nur, wer solche Dateien auch selbst
          herunterladen darf.
        </p>

        <p class="fehler" *ngIf="satzFehler">
          <mat-icon>error_outline</mat-icon>
          {{ satzFehler }}
        </p>

        <div class="form-aktionen">
          <button mat-button type="button" [disabled]="savingSatz" (click)="brichSatzAb()">
            Abbrechen
          </button>
          <button mat-raised-button color="primary" type="button" [disabled]="!satzIstGueltig || savingSatz"
            (click)="speichereSatz()">

            <mat-spinner diameter="18" *ngIf="savingSatz">
            </mat-spinner>


            <ng-container *ngIf="!savingSatz">

              <mat-icon>
                {{ satzForm.id == null ? 'cloud_upload' : 'save' }}
              </mat-icon>

              {{ satzForm.id == null ? 'Hochladen' : 'Speichern' }}

            </ng-container>

          </button>
        </div>

      </div>


      <p class="leer" *ngIf="parametersaetze.length === 0 && !satzForm">
        Für dieses Gerät ist noch keine Parameterdatei hinterlegt.
      </p>


      <!-- Vorhandene Parameterdateien -->
      <div class="satz" *ngFor="let satz of parametersaetze; trackBy: trackBySatz">

        <div class="satz-kopf" (click)="toggleSatz(satz)">

          <mat-icon class="satz-pfeil">
            {{ istOffen(satz) ? 'expand_more' : 'chevron_right' }}
          </mat-icon>

          <div class="satz-titel-block">
            <span class="satz-titel">
              {{ satz.bezeichnung }}
              <span class="chip-vertraulich" *ngIf="satz.istVertraulich"
                matTooltip="Download nur für berechtigte Rollen">
                <mat-icon inline>lock</mat-icon> vertraulich
              </span>
            </span>
            <span class="satz-sub">
              <ng-container *ngIf="satz.geraeteHersteller || satz.geraeteTyp">
                {{ satz.geraeteHersteller }}<ng-container *ngIf="satz.geraeteHersteller && satz.geraeteTyp"> ·
                </ng-container>{{ satz.geraeteTyp }}
                ·
              </ng-container>
              {{ satz.staende.length }} Stand{{ satz.staende.length === 1 ? '' : 'ände' }}
            </span>
          </div>

          <div class="satz-aktionen" *ngIf="canEdit" (click)="$event.stopPropagation()">
            <button mat-icon-button type="button" (click)="bearbeiteSatz(satz)" matTooltip="Parameterdatei bearbeiten">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="warn" type="button" (click)="loescheSatz(satz)"
              matTooltip="Parameterdatei mit allen Ständen löschen">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>

        </div>


        <div class="satz-inhalt" *ngIf="istOffen(satz)">

          <p class="satz-beschreibung" *ngIf="satz.beschreibung">{{ satz.beschreibung }}</p>

          <p class="satz-serie" *ngIf="satz.seriennummer">
            Seriennummer: <strong>{{ satz.seriennummer }}</strong>
          </p>

          <p class="hinweis" *ngIf="satz.istVertraulich && !satz.canDownload">
            <mat-icon>lock</mat-icon>
            Diese Datei ist als vertraulich markiert. Zum Herunterladen fehlt die
            Berechtigung – die Stände sind trotzdem nachvollziehbar aufgelistet.
          </p>


          <!-- Stände -->
          <p class="leer" *ngIf="satz.staende.length === 0">
            Noch keine Datei hinterlegt.
          </p>

          <div class="stand" *ngFor="let stand of satz.staende; trackBy: trackByStand"
            [class.stand-aktuell]="stand.istAktuell">

            <div class="stand-version">
              <span class="version-nr">v{{ stand.versionNr }}</span>
              <span class="version-marke" *ngIf="stand.istAktuell">aktuell</span>
            </div>

            <div class="stand-daten">
              <span class="stand-datei">{{ stand.fileName }}</span>
              <span class="stand-meta">
                {{ stand.hochgeladenAmUtc | date:'dd.MM.yyyy HH:mm' }}
                <ng-container *ngIf="stand.hochgeladenVon">· {{ stand.hochgeladenVon }}</ng-container>
                · {{ groesse(stand.sizeBytes) }}
              </span>
              <span class="stand-kommentar" *ngIf="stand.kommentar">„{{ stand.kommentar }}"</span>
              <span class="stand-summe" [matTooltip]="'SHA-256: ' + stand.sha256">
                SHA-256 {{ kurzeSumme(stand.sha256) }}…
              </span>
            </div>

            <div class="stand-aktionen">
              <button mat-icon-button type="button" [disabled]="!satz.canDownload || istStandLadend(stand)"
                (click)="ladeStandHerunter(stand)"
                [matTooltip]="satz.canDownload ? 'Herunterladen' : 'Zum Herunterladen fehlt die Berechtigung'">
                <mat-spinner diameter="18" *ngIf="istStandLadend(stand)"></mat-spinner>
                <mat-icon *ngIf="!istStandLadend(stand)">download</mat-icon>
              </button>

              <button mat-icon-button color="warn" type="button" *ngIf="canEdit" (click)="loescheStand(satz, stand)"
                matTooltip="Diesen Stand löschen">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>

          </div>


          <!-- Neuen Stand hochladen -->
          <div class="upload" *ngIf="canEdit">

            <input type="file" hidden #standInput (change)="onDateiAusgewaehlt(satz, $event)">

            <div class="upload-zeile" *ngIf="!gewaehlteDatei(satz)">
              <button mat-stroked-button type="button" (click)="standInput.click()">
                <mat-icon>upload_file</mat-icon>
                Neuen Stand hinzufügen
              </button>
              <span class="upload-hinweis">
                Bestehende Stände bleiben erhalten.
              </span>
            </div>

            <div class="upload-form" *ngIf="gewaehlteDatei(satz) as datei">

              <div class="upload-datei">
                <mat-icon>insert_drive_file</mat-icon>
                <span class="upload-name">{{ datei.name }}</span>
                <span class="upload-groesse">{{ groesse(datei.size) }}</span>
                <button mat-icon-button type="button" [disabled]="istUploadend(satz)" (click)="verwirfDatei(satz)"
                  matTooltip="Auswahl verwerfen">
                  <mat-icon>close</mat-icon>
                </button>
              </div>

              <mat-form-field appearance="outline" class="voll">
                <mat-label>Was hat sich geändert? (optional)</mat-label>
                <input matInput [ngModel]="standKommentar.get(satz.id) || ''"
                  (ngModelChange)="standKommentar.set(satz.id, $event)" [disabled]="istUploadend(satz)">
              </mat-form-field>

              <button mat-raised-button color="primary" type="button" [disabled]="istUploadend(satz)"
                (click)="ladeStandHoch(satz)">
                <mat-spinner diameter="18" *ngIf="istUploadend(satz)"></mat-spinner>
                <span *ngIf="!istUploadend(satz)">Stand speichern</span>
              </button>

            </div>

          </div>

        </div>

      </div>

    </ng-container>

  </mat-card-content>
</mat-card>


<!-- =====================================================
     ZUGANGSDATEN

     Passwörter und PINs des Geräts. Sie liegen ausschliesslich
     verschlüsselt in der Datenbank; der Klartext kommt erst auf
     Klick und wird dabei protokolliert.
     ===================================================== -->
<mat-card class="section-card" *ngIf="artefakte">
  <mat-card-content>

    <h2 class="section-title small">
      <mat-icon class="titel-icon">key</mat-icon>
      Zugangsdaten
      <span class="anzahl" *ngIf="zugangsdaten.length">{{ zugangsdaten.length }}</span>
    </h2>


    <!-- Ohne Rolle gibt es hier nichts zu sehen – auch nicht maskiert. -->
    <p class="hinweis gesperrt" *ngIf="!canSeeZugangsdaten">
      <mat-icon>lock</mat-icon>
      Geräte-Zugangsdaten sind einem eingeschränkten Personenkreis vorbehalten.
      Für diese Ansicht fehlt die Berechtigung.
    </p>


    <ng-container *ngIf="canSeeZugangsdaten">

      <p class="schutz-hinweis">
        <mat-icon>shield</mat-icon>
        Passwörter werden verschlüsselt gespeichert. Jedes Anzeigen und jede
        Änderung wird im Sicherheitsprotokoll festgehalten.
      </p>

      <div class="bereich-aktionen" *ngIf="!zugangForm">
        <button mat-stroked-button color="primary" type="button" *ngIf="canManageZugangsdaten"
          (click)="neueZugangsdaten()">
          <mat-icon>add</mat-icon>
          Zugangsdaten hinterlegen
        </button>

        <button mat-button type="button" *ngIf="klartext.size > 0" (click)="verbergeAlle()">
          <mat-icon>visibility_off</mat-icon>
          Alle ausblenden
        </button>
      </div>


      <!-- Formular -->
      <div class="form-box" *ngIf="zugangForm">

        <h3 class="form-titel">
          {{ zugangForm.id == null ? 'Neue Zugangsdaten' : 'Zugangsdaten bearbeiten' }}
        </h3>

        <div class="form-grid">

          <mat-form-field appearance="outline">
            <mat-label>Bezeichnung</mat-label>
            <input matInput [(ngModel)]="zugangForm.bezeichnung" [disabled]="savingZugang"
              placeholder="z. B. Service-Level Anzeige">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Zugangsart</mat-label>
            <input matInput [(ngModel)]="zugangForm.zugangsart" [disabled]="savingZugang"
              placeholder="z. B. HART, Webserver, Bluetooth">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Benutzername (optional)</mat-label>
            <input matInput [(ngModel)]="zugangForm.benutzername" [disabled]="savingZugang" autocomplete="off">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Passwort / PIN</mat-label>
            <input matInput type="password" [(ngModel)]="zugangForm.geheimnis" [disabled]="savingZugang"
              autocomplete="new-password">
            <mat-hint *ngIf="zugangForm.id != null">
              Leer lassen, um das gespeicherte Passwort unverändert zu lassen.
            </mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" class="voll">
            <mat-label>Notiz (wird ebenfalls verschlüsselt)</mat-label>
            <textarea matInput rows="2" [(ngModel)]="zugangForm.notiz" [disabled]="savingZugang"></textarea>
          </mat-form-field>

        </div>

        <p class="fehler" *ngIf="zugangFehler">
          <mat-icon>error_outline</mat-icon>
          {{ zugangFehler }}
        </p>

        <div class="form-aktionen">
          <button mat-button type="button" [disabled]="savingZugang" (click)="brichZugangAb()">
            Abbrechen
          </button>
          <button mat-raised-button color="primary" type="button" [disabled]="!zugangIstGueltig || savingZugang"
            (click)="speichereZugangsdaten()">
            <mat-spinner diameter="18" *ngIf="savingZugang"></mat-spinner>
            <span *ngIf="!savingZugang">Speichern</span>
          </button>
        </div>

      </div>


      <p class="leer" *ngIf="zugangsdaten.length === 0 && !zugangForm">
        Für dieses Gerät sind keine Zugangsdaten hinterlegt.
      </p>


      <!-- Einträge -->
      <div class="zugang" *ngFor="let z of zugangsdaten; trackBy: trackByZugang">

        <div class="zugang-kopf">

          <div class="zugang-titel-block">
            <span class="zugang-titel">{{ z.bezeichnung }}</span>
            <span class="zugang-sub">
              <ng-container *ngIf="z.zugangsart">{{ z.zugangsart }} · </ng-container>
              geändert {{ z.geaendertAmUtc | date:'dd.MM.yyyy HH:mm' }}
              <ng-container *ngIf="z.geaendertVon">· {{ z.geaendertVon }}</ng-container>
            </span>
            <span class="zugang-sub" *ngIf="z.zuletztAngezeigtAmUtc">
              zuletzt angezeigt {{ z.zuletztAngezeigtAmUtc | date:'dd.MM.yyyy HH:mm' }}
              <ng-container *ngIf="z.zuletztAngezeigtVon">· {{ z.zuletztAngezeigtVon }}</ng-container>
            </span>
          </div>

          <div class="zugang-aktionen">

            <button mat-stroked-button type="button" *ngIf="!istAufgedeckt(z)" [disabled]="istAufdeckend(z)"
              (click)="deckeAuf(z)">
              <mat-spinner diameter="18" *ngIf="istAufdeckend(z)"></mat-spinner>
              <ng-container *ngIf="!istAufdeckend(z)">
                <mat-icon>visibility</mat-icon>
                Anzeigen
              </ng-container>
            </button>

            <button mat-stroked-button type="button" *ngIf="istAufgedeckt(z)" (click)="verberge(z)">
              <mat-icon>visibility_off</mat-icon>
              Ausblenden
            </button>

            <button mat-icon-button type="button" *ngIf="canManageZugangsdaten" (click)="bearbeiteZugangsdaten(z)"
              matTooltip="Bearbeiten">
              <mat-icon>edit</mat-icon>
            </button>

            <button mat-icon-button color="warn" type="button" *ngIf="canManageZugangsdaten"
              (click)="loescheZugangsdaten(z)" matTooltip="Löschen">
              <mat-icon>delete_outline</mat-icon>
            </button>

          </div>

        </div>


        <!-- Klartext, nur solange aufgedeckt -->
        <div class="zugang-klartext" *ngIf="aufgedeckt(z) as k">

          <p class="fehler" *ngIf="k.unlesbar">
            <mat-icon>error_outline</mat-icon>
            Das gespeicherte Geheimnis lässt sich nicht entschlüsseln – vermutlich
            fehlt der ursprüngliche Schlüsselbund. Der Eintrag muss neu erfasst
            werden.
          </p>

          <ng-container *ngIf="!k.unlesbar">

            <div class="klartext-zeile" *ngIf="k.benutzername">
              <span class="klartext-label">Benutzername</span>
              <code class="klartext-wert">{{ k.benutzername }}</code>
              <button mat-icon-button type="button" (click)="kopiere(k.benutzername, 'Benutzername')"
                matTooltip="Kopieren">
                <mat-icon>content_copy</mat-icon>
              </button>
            </div>

            <div class="klartext-zeile">
              <span class="klartext-label">Passwort / PIN</span>
              <code class="klartext-wert">{{ k.geheimnis }}</code>
              <button mat-icon-button type="button" (click)="kopiere(k.geheimnis, 'Passwort')" matTooltip="Kopieren">
                <mat-icon>content_copy</mat-icon>
              </button>
            </div>

            <div class="klartext-zeile" *ngIf="k.notiz">
              <span class="klartext-label">Notiz</span>
              <span class="klartext-notiz">{{ k.notiz }}</span>
            </div>

          </ng-container>

        </div>

      </div>

    </ng-container>

  </mat-card-content>
</mat-card>


<!-- =====================================================
     SICHERHEITSPROTOKOLL

     Wer hat wann welche Datei hoch- oder heruntergeladen und
     wer Zugangsdaten angesehen. Rein lesend; Einträge werden
     nie überschrieben oder gelöscht.
     ===================================================== -->
<mat-card class="section-card" *ngIf="artefakte && canSeeZugangsdaten">
  <mat-card-content>

    <h2 class="section-title small klickbar" (click)="toggleAudit()">
      <mat-icon class="titel-icon">policy</mat-icon>
      Sicherheitsprotokoll
      <span class="anzahl" *ngIf="audit.length">{{ audit.length }}</span>
      <mat-icon class="audit-pfeil">
        {{ auditOffen ? 'expand_less' : 'expand_more' }}
      </mat-icon>
    </h2>

    <ng-container *ngIf="auditOffen">

      <div class="lade" *ngIf="auditLaedt">
        <mat-spinner diameter="28"></mat-spinner>
      </div>

      <p class="fehler" *ngIf="auditFehler">
        <mat-icon>error_outline</mat-icon>
        {{ auditFehler }}
      </p>

      <p class="leer" *ngIf="!auditLaedt && !auditFehler && audit.length === 0">
        Für dieses Gerät wurde noch keine sicherheitsrelevante Aktion erfasst.
      </p>

      <div class="audit-liste" *ngIf="audit.length">

        <div class="audit-eintrag" *ngFor="let e of audit; trackBy: trackByAudit"
          [class.audit-abgelehnt]="!e.erfolgreich">

          <mat-icon class="audit-icon">{{ auditIcon(e) }}</mat-icon>

          <div class="audit-inhalt">

            <div class="audit-kopf">
              <span class="audit-zeit">{{ e.zeitpunktUtc | date:'dd.MM.yyyy HH:mm' }}</span>
              <span class="audit-benutzer" *ngIf="e.benutzerName">{{ e.benutzerName }}</span>
              <span class="audit-ip" *ngIf="e.ipAdresse">{{ e.ipAdresse }}</span>
            </div>

            <div class="audit-titel">
              {{ e.aktionText }}
              <ng-container *ngIf="e.artefaktBezeichnung">: {{ e.artefaktBezeichnung }}</ng-container>
            </div>

            <div class="audit-detail" *ngIf="e.detail">{{ e.detail }}</div>

          </div>

        </div>

      </div>

    </ng-container>

  </mat-card-content>
</mat-card>